<div class="menu-top" #menuContainer>
   <div class="menu-bar">
      <span id="portalLogoLink" class="app-title" #left routerLink="/" (click)="left.blur()">
         <span id="portalLogo" class="logo"></span>

         <span id="portalAppName" class="app-name button-ish">{{navMenu.title | uppercase}}</span>
      </span>

      <div #navContainer>
         <lib-nav-menu *ngIf="!hamburger && ( navMenu.below$ | async ) === false" [project]="project"></lib-nav-menu>
      </div>

      <lib-action-menu *ngIf="!hamburger"></lib-action-menu>

      <lib-menu-xsmall *ngIf="hamburger" [project]="project"></lib-menu-xsmall>
   </div>

   <lib-nav-menu *ngIf="!hamburger && ( navMenu.below$ | async )" [project]="project"></lib-nav-menu>

   <lib-activity-bar></lib-activity-bar>

   <lib-menu-error-bar></lib-menu-error-bar>
</div>
